<div class="cbc-notification-dialog">
  <div class="cbc-notification-default">
    <span>Default Value: &nbsp;&nbsp;&nbsp; {{notificationDefaultValue}}</span>
  </div>

  <div class="cbc-notification-overwrite">
    <mat-checkbox class="example-margin" [(ngModel)]="notificationOverwrite">Overwrite</mat-checkbox>
    <mat-radio-group class="overwrite-options" [(ngModel)]="overwrittenCellValue">
      <mat-radio-button class="overwrite-option-value" [disabled]="!notificationOverwrite"  value="Yes">Yes</mat-radio-button>
      <mat-radio-button class="overwrite-option-value" [disabled]="!notificationOverwrite"  value="No">No</mat-radio-button>
    </mat-radio-group>
  </div>
</div>
